import React, { useState } from 'react';
import LeftMenu from './Sections/LeftMenu';
import RightMenu from './Sections/RightMenu';
import { Drawer, Button } from 'antd';
import { AlignRightOutlined } from '@ant-design/icons';
import './Sections/Navbar.css';

function NavBar() {
  const [visible, setVisible] = useState(false);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  return (
    <nav
      className="menu"
      style={{ position: 'fixed', zIndex: 5, width: '100%' }}
    >
      <div className="menu__logo">
        <a href="/" aria-label="リ・カレント サーベイシステム ホーム">
          {/* 2026-10 高画質版に差し替え（300×102・表示は .menu__logo の幅 150px＝2倍密度）。旧 /logo.png は確定後に削除 */}
          <img src="/logo-recurrent-2026.png" width="100%" alt="リ・カレント" />
        </a>
      </div>
      <div className="menu__container">
        <div className="menu_left">
          <LeftMenu mode="horizontal" />
        </div>
        <div className="menu_rigth">
          <RightMenu mode="horizontal" />
        </div>
        <Button
          className="menu__mobile-button"
          type="primary"
          onClick={showDrawer}
          aria-label="メニューを開く"
          aria-haspopup="dialog"
          aria-expanded={visible}
          aria-controls="mobile-menu-drawer"
        >
          <AlignRightOutlined />
        </Button>
        <Drawer
          id="mobile-menu-drawer"
          title="メニュー"
          placement="right"
          className="menu_drawer"
          /* 旧来は width 未指定で antd 既定 378px ＝ スマホ幅をほぼ覆い、外側タップで
             閉じる余白がほぼ無かった。幅を絞り（最大 300px / 画面の 85%）、左側に
             ドロワー外をタップして閉じられる領域を確保する。 */
          width={'min(85vw, 300px)'}
          closable={false}
          onClose={onClose}
          open={visible}
        >
          <LeftMenu mode="inline" />
          <RightMenu mode="inline" />
        </Drawer>
      </div>
    </nav>
  );
}

export default NavBar;
